// extracted by mini-css-extract-plugin
module.exports = {"oddsInput":"SelectionsTableRow_oddsInput__2_JDa","oddsDuration":"SelectionsTableRow_oddsDuration__1rRkO"};